import React from 'react';
import { Layout } from 'antd';
const { Content } = Layout;

import Browse from 'components/Portal/FieldPrograms/Browse';
import { getBrandBlue } from '../../theme';

export default class FieldPrograms extends React.Component {
	state = {
		blue: '#0069aa',
		eventID: null,
	};

	setEventID = () => {
		let eventIDParam = this.props.match.params.eventID; // this isn't really an event Id, the URL used uses the eventCode instead. ex. /#/fieldprograms/SP20

		if (this.props.voyages.length === 0) {
			this.setState({ eventID: null });
			return;
		}

		const event = this.props.voyages.find((voyage) => {
			return voyage.id === eventIDParam || voyage.code.toLowerCase() === eventIDParam;
		});

		this.setState({ eventID: event ? event.id : undefined });
	};

	componentDidMount() {
		const blue = getBrandBlue();
		this.setState({ blue });
		document.body.style.backgroundColor = blue;

		this.setEventID();
	}

	componentDidUpdate(prevProps) {
		if (this.props.voyages.length !== prevProps.voyages.length) {
			this.setEventID();
		}
	}

	render() {
		return (
			<Layout>
				<Content>
					<div className='withSpacing'>
						<Browse
							noCartButtons
							noTopBanners
							noPagination
							GSCneeded={false}
							showSpotsLeft={false}
							showBanners={true}
							booking={{ EventId: this.state.eventID, TripCode: this.props.match.params.tripCode }}
							bookedItems={[]}
						/>
					</div>
				</Content>
			</Layout>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/FieldPrograms/index.jsx